<template>
  <div class="home_page">
    <Menu :menuList="menuList" />
    <section :class="[collapsed ? 'secwidth80' : 'secwidth180']">
      <Header />
      <div class="content_box">
        <div class="router_list">
          <Label :left.sync="labelLeft" />
        </div>
        <div class="content_view">
          <keep-alive :include="keepArr">
            <router-view />
          </keep-alive>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Label from "./Label.vue";
import { mapGetters, mapState } from "vuex";
import { menuList } from "@/config/routerConfig";
import Header from "./Header.vue";

export default {
  name: "Home",
  data() {
    return {
      menuList: [],
      labelLeft: 0,
      keepArr: []
    };
  },
  created() {
    let arr = this.$store?.getters?.getUserInfo?.rolePermissions?.split(";") || [];
    this.menuList = this.getPermissions(menuList, arr);
    this.$store.commit("SET_MENULIST", this.menuList);
    this.keepArr = this.getLabelList.map(item => {
      return item.name;
    });
  },
  computed: {
    ...mapGetters(["getLabelList"]),
    ...mapState(["collapsed"])
  },
  watch: {
    getLabelList: function() {
      this.keepArr = this.getLabelList.map(item => {
        return item.name;
      });
    }
  },
  methods: {
    getPermissions(menuList, powers) {
      if (powers?.[0] === "ALL") return menuList;
      const result = [];
      menuList.forEach(menu => {

        if (powers.includes(menu.auth)) {
          const obj = {
            title: menu.title,
            auth: menu.auth,
            path: menu.path,
            icon: menu.icon
          };
          if (menu.children) {
            obj.children = menu.children.filter(subMenu => powers.includes(subMenu.auth));
          }
          result.push(obj);
        }
      });
      return result;
    }
  },
  components: {
    Menu,
    Label,
    Header
  }
};
</script>

<style lang="less" scoped>
@theme-color: #6ebf89;
@border-color: #dddddd;

.home_page {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;

  .secwidth180 {
    width: calc(100% - 180px);
  }

  .ant-menu-submenu-title {
    font-size: 16px;
  }

  .secwidth80 {
    width: calc(100% - 80px);
  }

  > section {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    > nav {
      height: 100%;
      background: #3d3f42;
      box-sizing: border-box;
    }

    > .content_box {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      min-width: 1100px;
      overflow-x: auto;

      > .router_list {
        height: 44px;
        background: #ffffff;
        border-bottom: 1px solid #f4f4f4;
      }

      > .content_view {
        width: 100%;
        flex: 1;
        //background: #fff;
        padding: 20px;
        box-sizing: border-box;
        overflow: auto;
      }
    }
  }

  /*快速检索框样式*/

  #retrieve_box {
    width: 100%;
    height: auto;
    background: #ffffff;
    border-radius: 5px;
    padding: 80px 25px 30px;
    box-sizing: border-box;
    position: relative;
    font-size: 16px;
    color: #333333;

    &::before {
      content: "";
      width: 6px;
      height: 30px;
      background: @theme-color;
      position: absolute;
      top: 25px;
      left: 0;
    }

    &::after {
      content: "快速检索";
      line-height: 30px;
      font-size: 22px;
      position: absolute;
      top: 25px;
      left: 25px;
    }
  }

  /*表格样式*/

  .ant-table-body {
    border: 1px solid @border-color;
    border-bottom: 0;

    .ant-table-thead {
      background: #e8ece9;
    }

    .ant-table-tbody {
      tr:nth-child(2n) {
        background: #fafbfe;
      }

      tr:nth-child(2n + 1) {
        background: #ffffff;
      }
    }
  }
}
</style>
